import { combineReducers } from "redux";
import answersReducer from "./reducers/answers";
import { AnswersState } from "./reducers/answers/reducer";
import authReducer, { AuthState } from "./reducers/auth/reducer";
import eventsReducer from "./reducers/events";
import usersReducer from "./reducers/users";
import { TastingEventsState } from "./reducers/events/reducer";
import resultsReducer from "./reducers/results";
import { ResultsState } from "./reducers/results/reducer";
import { UsersState } from "./reducers/users/reducer";
import { BeersState } from "./reducers/beers/reducer";
import beersReducer from "./reducers/beers";
import accountReducer from "./reducers/account";
import { AccountState } from "./reducers/account/reducer";

export type RootState = {
  auth: AuthState;
  events: TastingEventsState;
  answers: AnswersState;
  results: ResultsState;
  users: UsersState;
  beers: BeersState;
  account: AccountState;
};

export type UserInfo = {
  uid: string;
  email: string;
};

export { StoreError } from "./errors";

const rootReducer = combineReducers<RootState>({
  auth: authReducer,
  events: eventsReducer,
  answers: answersReducer,
  results: resultsReducer,
  users: usersReducer,
  beers: beersReducer,
  account: accountReducer,
});
export default rootReducer;
